export function normalizeMapTilerKey(value: string | undefined | null): string {
  return value?.trim() ?? "";
}

export function hasMapTilerKey(value: string | undefined | null): boolean {
  return normalizeMapTilerKey(value).length > 0;
}

export function redactMapTilerKey(value: string): string {
  const key = normalizeMapTilerKey(value);
  if (!key) {
    return "";
  }

  if (key.length <= 8) {
    return "*".repeat(key.length);
  }

  return `${key.slice(0, 4)}...${key.slice(-4)}`;
}
